import React from 'react';
import { Stack } from '@mui/material';
import {
  ICandidateSourcingSearch,
  ICandidateSourcingFilters,
  FilterKey,
  filterToLabel
} from './types';
import Tag from '../Components/Tag/Tag';

const allFilters = Object.keys(filterToLabel) as FilterKey[];

export default function FiltersBreakdown({
  searchObject,
  setSearchObject,
  optionsCleared
}: {
  searchObject: ICandidateSourcingSearch;
  setSearchObject: (searchObject: ICandidateSourcingSearch) => void;
  optionsCleared: boolean;
}) {
  const filters = (searchObject.filters || {}) as ICandidateSourcingFilters;
  const filterOptions = optionsCleared ? {} : searchObject.filter_options || {};

  const handleAddJobTitle = async () => {
    const newJobTitles = [...(filters.job_titles || []), ''];
    setSearchObject({
      ...searchObject,
      filters: { ...filters, job_titles: newJobTitles }
    });
  };

  const handleAddSkill = async () => {
    const newSkills = [...(filters.skills || [])];
    newSkills[newSkills.length - 1].push('');

    setSearchObject({
      ...searchObject,
      filters: { ...filters, skills: newSkills }
    });
  };

  const handleAddIndustry = async () => {
    const newIndustries = [...(filters.industries || []), ''];
    setSearchObject({
      ...searchObject,
      filters: { ...filters, industries: newIndustries }
    });
  };

  const isFilterActive = (filterKey: FilterKey) => {
    const value = filters[filterKey];
    if (value === undefined || value === null) return false;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  };

  return (
    <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 1 }}>
      {allFilters.map((filterKey) => {
        const active = isFilterActive(filterKey);
        const hasOptions = filterOptions[filterKey] && filterOptions[filterKey].length > 0;

        return (
          <Tag
            key={filterKey}
            label={filterToLabel[filterKey]}
            backgroundColor={active ? '#E3F2FD' : '#F5F5F5'}
            color={active ? '#1976D2' : '#757575'}
            isInteractive={active && hasOptions}
            options={['Add']}
            onSelect={(option) => {
              if (option === 'Add') {
                if (filterKey === 'job_titles') {
                  handleAddJobTitle();
                } else if (filterKey === 'skills') {
                  handleAddSkill();
                } else if (filterKey === 'industries') {
                  handleAddIndustry();
                }
              }
            }}
          />
        );
      })}
    </Stack>
  );
}
